var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "admin-app" } },
    [
      _c(
        "nav-bar",
        {
          attrs: {
            currentProduct: "admin",
            enabledApps: _vm.enabledApps,
            showAdmin: "",
            "support-url": _vm.supportUrl,
            "support-contact-url": _vm.supportContactUrl,
            userName: _vm.userName,
            userInfo: _vm.userInfo,
            sideLinks: _vm.sideMenu,
          },
          on: { "sign-out": _vm.logout, "secret-meta-click": _vm.impersonate },
        },
        [
          _c(
            "div",
            {
              staticClass: "appBody styleScroll",
              attrs: { slot: "body" },
              slot: "body",
            },
            [
              _c("div", { staticClass: "navbar-slot" }, [
                _c(
                  "div",
                  { staticClass: "collector-panel" },
                  [_c("collection-status-panel")],
                  1
                ),
                _vm._v(" "),
                _vm.isSU
                  ? _c(
                      "div",
                      { staticClass: "org-change-field" },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            clearable: "",
                            items: _vm.organizations,
                            label: "Organization",
                            "item-text": "text",
                            "item-value": "value",
                            disabled: _vm.orgSelectionLock,
                          },
                          on: { change: _vm.orgChange },
                          model: {
                            value: _vm.orgid,
                            callback: function ($$v) {
                              _vm.orgid = $$v
                            },
                            expression: "orgid",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content-wrapper main-content-container nav-footer-fix",
                },
                [_c("router-view")],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("impersonation-panel", {
        attrs: { show: _vm.showImpersonate },
        on: { "impersonate-complete": _vm.reset },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }